export const policyTemplates = {
  admin: {
    '28d3dbac-2ac1-4bca-b023-5ca5a6480c62': [
      'admin:CreateUser',
      'admin:DeleteUser',
      'admin:ListUsers',
    ],
    '2CSnCar8V24CA2gIOQAcz8oKxrwFCDCak5bKs1U8': [
      'pylo:PlaceOrder',
      'pylo:GetDevices',
      'pylo:GetOrders',
      'pylo:GetReadings',
    ],
  },
  dev: {
    '5CtBo3JQOj2xAVfsi57om6LNjWgvSqvf3V5EXkVE': [
      'pylo:GetDevices',
      'pylo:GetOrders',
      'pylo:GetReadings',
    ],
  },
};

const user_role_actions = {
  admin: [
    'Admin: Create User', 
    'Admin: Delete User',
    'Admin: List Users',
    'Admin: Deactivate Devices',
    'Admin: Create API Key', 
    'Admin: Edit Webhook',
    'Dev: Place Order',
    'Dev: Get Devices',
    'Dev: Get Orders',
    'Dev: Get Readings',
  ],
  developer: [
    'Dev: Place Order',
    'Dev: Get Devices',
    'Dev: Get Orders',
    'Dev: Get Readings',
  ],
  user: [
    'Dev: Get Devices',
    'Dev: Get Orders',
    'Dev: Place Order',
  ],
};

export const policies = {
  admin: {
    list: user_role_actions.admin,
    id: '28d3dbac-2ac1-4bca-b023-5ca5a6480c62',
  },
  dev: {
    list: user_role_actions.developer,
    id: '5CtBo3JQOj2xAVfsi57om6LNjWgvSqvf3V5EXkVE',
  },
  user: {
    list: user_role_actions.user,
    id: '2CSnCar8V24CA2gIOQAcz8oKxrwFCDCak5bKs1U8',
  },
};

export const selectItems = [
  { label: 'User Role', name: 'role', list: ['Admin', 'Developer', 'User'] },
];
